export class InviteRequestGenericError extends Error {}
